// ! import all of the widget functions
import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

// Make Swiper available globally
window.Swiper = Swiper;
window.SwiperModules = { Navigation };

import { servicesTabs } from "../../widgets/services-tabs/src/widget";
import { partnersMarquee } from "../../widgets/partners-marquee/src/widget";
import { teamCarousels } from "../../widgets/team-carousels/src/widget";
import { stickerWipeOn, fadeInUp } from "./utils";


// ------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function() { 

    servicesTabs();
    teamCarousels();
    partnersMarquee();

    // Toggle the open menu class
const toggleMenu = () => {
    const menuBtn = document.querySelector('.menu-btn')
    const hamburger = document.querySelector('.hamburger')
    if(menuBtn === null) return
    const bodyTag = document.querySelector('body')
    menuBtn.addEventListener('click', () => {
        bodyTag.classList.toggle('menu-open')
        hamburger.classList.toggle('is-active')
        // handleFixedBody()
    })
}
toggleMenu()
    
    // ! Call all of the widget scripts here.
    stickerWipeOn(".sticker", {
        rotationRange: 8,
        stagger: 0.2,
    }); // example usage of the stickerWipeOn widget
    

    fadeInUp('.fade-in-up', {
        duration: 0.5,
        stagger: 0.15,
        yStart: 40
    });

});
